import axios from "axios";
import { toastr } from "react-redux-toastr";

import { openModal } from "./modalAction";

import {
  FETCH_PROPOVERVIEW,
  SEARCH_PROPOVERVIEWS,
  FETCHING_PROPOVERVIEWS,
} from "./types";

//search  PropOverviews

export const searchPropOverviews = () => async (dispatch) => {
  try {
    const res = await axios.post("/api/PropOverviewSearch");

    dispatch({ type: SEARCH_PROPOVERVIEWS, payload: res.data });
    dispatch({ type: FETCHING_PROPOVERVIEWS, payload: false });
    // dispatch(closeModal());
  } catch (error) {
    console.log("error_searchPropOverview", error);
    if (error && error.response && error.response.status == 401) {
      dispatch(openModal("LoginModal"));
      toastr.error(`${JSON.stringify(error.response.data)}`);
    } else if (error) {
      toastr.error(
        "Oops",
        "Something went wrong.Please Try Again_searchPropOverview"
      );
    }
  }
};

//fetch single PropOverview
export const fetchPropOverview = (id) => async (dispatch) => {
  try {
    const res = await axios.get(`/api/PropOverviewDetail/${id}`);

    dispatch({ type: FETCH_PROPOVERVIEW, payload: res.data });
  } catch (error) {
    console.log("error_detailPropOverview", error);
    if (error && error.response && error.response.status == 401) {
      dispatch(openModal("LoginModal"));
      toastr.error(`${JSON.stringify(error.response.data)}`);
    } else if (error) {
      toastr.error("Oops", "Something went wrong.Please Try Again__detailPropOverview");
    }
  }
};

// create PropOverview
export const createPropOverview = (values) => async (dispatch) => {
  try {
    const res = await axios.post("/api/PropOverviewCreate", {
      values,
    });

    if (res.data.msg === "success") {
      toastr.success("PropOverview Created");
    }
  } catch (error) {
    if (error && error.response && error.response.status == 401) {
      dispatch(openModal("LoginModal"));
      toastr.error(`${JSON.stringify(error.response.data)}`);
    } else if (error) {
      toastr.error("Oops", "Something went wrong.Please Try Again");
    }
  }
};

//reset PropOverview
export const resetPropOverview = () => async (dispatch) => {
  try {
    dispatch({ type: FETCH_PROPOVERVIEW, payload: null });
  } catch (error) {
    toastr.error("Oops", "Something went wrong.Please Try Again");
  }
};
